import { Phone, MessageCircle, Menu, X } from "lucide-react";

const Header = ({ isMenuOpen, setIsMenuOpen, isHomePage = true }) => {
  const navLinks = [
    { href: "#about", label: "About" },
    { href: "#treatment", label: "Treatment" },
    { href: "#results", label: "Results" },
    { href: "#faq", label: "FAQ" },
    { href: "#booking", label: "Contact" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    if (isHomePage) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        setIsMenuOpen(false);
      }
    } else {
      window.location.href = "/" + href;
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 shadow-sm" data-testid="header">
      <div className="section-container">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2" data-testid="logo-link">
            <img src="/images/logo.webp" alt="Sky's PhysioRehab Logo" className="w-12 h-12 object-contain" />
            <div className="block">
              <p className="font-serif font-bold text-blue-900 text-sm sm:text-base leading-tight">Sky's PhysioRehab</p>
              <p className="text-[10px] sm:text-[11px] text-stone-500">& Slimming Centre</p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="text-stone-600 hover:text-blue-700 font-medium text-sm transition-colors"
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center gap-2 md:gap-4">
            <a
              href="tel:+918800095625"
              className="hidden md:flex items-center gap-2 text-blue-700 hover:text-blue-800 font-medium text-sm"
              data-testid="header-call-btn"
            >
              <Phone size={18} />
              <span className="hidden lg:inline">+91 88000 95625</span>
            </a>
            <a
              href="https://wa.me/918800095625?text=Hi%2C%20I%20want%20to%20book%20a%20consultation%20for%20Diastasis%20Recti%20Treatment"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp flex items-center gap-2 text-sm py-2 px-4"
              data-testid="header-whatsapp-btn"
            >
              <MessageCircle size={18} />
              <span className="hidden sm:inline">WhatsApp</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 text-stone-600 hover:text-blue-700"
              data-testid="mobile-menu-toggle"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-stone-100" data-testid="mobile-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="block py-3 text-stone-600 hover:text-blue-700 font-medium transition-colors"
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+918800095625"
              className="flex items-center gap-2 py-3 text-blue-700 font-medium"
              data-testid="mobile-call-btn"
            >
              <Phone size={18} />
              +91 88000 95625
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
